import React from "react";
import { actions } from "realwarebinder";
import { connect } from "react-redux";
import { NamespacesConsumer, translate } from "react-i18next";
import qdmstyles from "./styles.json";
import { withRouter } from "react-router-dom";
import { Modal } from "qdm-component-library";
import "./index.css";
import { languageOptions, fieldValidator } from "../../utils";
import { LoggerContext } from "../../contexts";
import { withAllContexts } from "../../HOCs";
import { Logout } from "../../components";

import * as ALL from "../../components";

import { TextInput, Dropdown } from "qdm-component-library";

class AddSpecialistDoctor extends React.Component {
  static contextType = LoggerContext;
  constructor(props, context) {
    super(props, context);
    this.state = {
      add_specialist_doctor_obmtw: null,
      add_specialist_doctor_yhvxc: null,
      add_specialist_doctor_9h6ec: null,
      add_specialist_doctor_shksf: null,
      add_specialist_doctor_naiin: null,
      add_specialist_doctor_gfves: null,
      add_specialist_doctor_psudy: null,
      validations: {
        DoctorName: false,
        Speciality: false,
        Location: false,
        EmailId: false,
        MobileNumber: false,
        Address: true,
      },
      isError: [],
      isEmail: []
    };
  }

  changeState = (key, value) => {
    this.setState({
      [key]: value,
    });
  };
  onchange_obmtw = (e) => {
    
    let result = fieldValidator("name", e.target.value);

    if (this.state.isError?.includes("DoctorName")) {
      this.setState({
        ...this.state,
        isError: this.state.isError.filter(v => v !== 'DoctorName')
      });
    }

    if (result) {
      this.setState({
        validations: {
          ...this.state.validations,
          DoctorName: true,
        },
        add_specialist_doctor_obmtw: e?.target?.value,
      });
    } else {
      this.setState({
        validations: {
          ...this.state.validations,
          DoctorName: false,
        },
        add_specialist_doctor_obmtw: e?.target?.value,
      });
    }
  };

  onchange_yhvxc = (e) => {
    let result = fieldValidator("stringWithNumber", e?.label);

    if (this.state.isError?.includes("Speciality")) {
      this.setState({
        ...this.state,
        isError: this.state.isError.filter(v => v !== 'Speciality')
      });
    }
    if (result) {
      this.setState({
        validations: {
          ...this.state.validations,
          Speciality: true,
        },
        add_specialist_doctor_yhvxc: e,
      });
    } else {
      this.setState({
        validations: {
          ...this.state.validations,
          Speciality: false,
        },
        add_specialist_doctor_yhvxc: e,
      });
    }
  };

  onchange_9h6ec = (e) => {
    let result = fieldValidator("string", e?.label);

    if (this.state.isError?.includes("Location")) {
      this.setState({
        ...this.state,
        isError: this.state.isError.filter(v => v !== 'Location')
      });
    }
    if (result) {
      this.setState({
        validations: {
          ...this.state.validations,
          Location: true,
        },
        add_specialist_doctor_9h6ec: e,
      });
    } else {
      this.setState({
        validations: {
          ...this.state.validations,
          Location: false,
        },
        add_specialist_doctor_9h6ec: e,
      });
    }
  };

  onchange_shksf = (e) => {
    let result = fieldValidator("emailId", e.target.value);

    if (this.state.isError?.includes("EmailId")) {
      this.setState({
        ...this.state,
        isError: this.state.isError.filter(v => v !== 'EmailId')
      });
    }
    if (result) {
      this.setState({
        validations: {
          ...this.state.validations,
          EmailId: true,
        },
        add_specialist_doctor_shksf: e?.target?.value,
      });
    } else {
      this.setState({
        validations: {
          ...this.state.validations,
          EmailId: false,
        },
        add_specialist_doctor_shksf: e?.target?.value,
      });
    }
  };

  onchange_naiin = (e) => {
    let result = fieldValidator("mobileNumber", e.target.value);

    if (this.state.isError?.includes("MobileNumber")) {
      this.setState({
        ...this.state,
        isError: this.state.isError.filter(v => v !== 'MobileNumber')
      });
    }
    if (!this.state.add_specialist_doctor_naiin) {
      e.target.value = "01" + e?.target?.value
    }
    if (result) {
      this.setState({
        validations: {
          ...this.state.validations,
          MobileNumber: true,
        },
        add_specialist_doctor_naiin: e?.target?.value,
      });
    } else {
      this.setState({
        validations: {
          ...this.state.validations,
          MobileNumber: false,
        },
        add_specialist_doctor_naiin: e?.target?.value,
      });
    }
  };

  onchange_gfves = (e) => {
    let result = fieldValidator("address", e.target.value);

    if (result) {
      this.setState({
        validations: {
          ...this.state.validations,
          Address: true,
        },
        add_specialist_doctor_gfves: e?.target?.value,
      });
    } else {
      this.setState({
        validations: {
          ...this.state.validations,
          Address: false,
        },
        add_specialist_doctor_gfves: e?.target?.value,
      });
    }
  };

  validationResponse = (data) => {
    if (
      !data.add_specialist_doctor_9h6ec &&
      // !data.add_specialist_doctor_gfves&&
      !data.add_specialist_doctor_naiin &&
      !data.add_specialist_doctor_obmtw &&
      !data.add_specialist_doctor_shksf &&
      !data.add_specialist_doctor_yhvxc
    ) {
      return true;
    }
    // let status = Object.keys(data).findIndex((key, index) => {
    //   if (
    //     key !== "data" &&
    //     key !== "history" &&
    //     key !== "add_specialist_doctor_gfves"
    //   ) {
    //     if (!data[key]) {
    //       this.props.alert.setSnack({
    //         open: true,
    //         msg: "Fill In All Required fields",
    //         severity: "error",
    //       });
    //       return true;
    //     }
    //   }
    // });
    // if (status == -1) return false;
    // else return true;
  };
  onclick_psudy = async (event, data) => {
    

    const payload0 = {
      add_specialist_doctor_obmtw: this.state.add_specialist_doctor_obmtw,

      add_specialist_doctor_yhvxc:
        this.state.add_specialist_doctor_yhvxc?.label,

      add_specialist_doctor_9h6ec:
        this.state.add_specialist_doctor_9h6ec?.label,

      add_specialist_doctor_gfves: this.state.add_specialist_doctor_gfves,

      add_specialist_doctor_naiin: this.state.add_specialist_doctor_naiin,

      add_specialist_doctor_shksf: this.state.add_specialist_doctor_shksf,
      history: this.props.history.location.state,
      data: data,
    };

    //   validation
    if (this.validationResponse(payload0)) {
      this.setState({ ...this.state, isError: ['MobileNumber', 'EmailId', 'Location', 'Speciality', 'DoctorName'] })
      this.props.alert.setSnack({
        open: true,
        msg: "Fill in all the required fields",
        severity: "error",
      })
      return;
    }

    //   validation
    if (!Object.values(this.state.validations).every((val) => val === true)) {
      let result = Object.entries(this.state.validations).reduce(
        (allVal, val) => {
          if (val[1] === false) {
            return [val[0], ...allVal];
          } else {
            return [...allVal];
          }
        },
        []
      );

      //   validation
      if (this.state.add_specialist_doctor_shksf && (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.add_specialist_doctor_shksf))) {
        this.setState({ ...this.state, isError: [...this.state.isError, 'EmailId'] })
        return this.props.alert.setSnack({
          open: true,
          msg: `Enter the valid email id`,
          severity: "error",
        });
      }
      //   validation
      const _ = this.state.isEmail.filter(v => v === this.state.add_specialist_doctor_shksf)
      if (_?.length > 0) {
        this.setState({ ...this.state, isError: [...this.state.isError, 'EmailId'] })
        return this.props.alert.setSnack({
          open: true,
          msg: `Your email id is already exit`,
          severity: "error",
        });
      }
      this.setState({ ...this.state, isError: [...result, ...this.state.isError] })
      //   validation
      return this.props.alert.setSnack({
        open: true,
        msg: `Input fields-${result.join(", ")} are not in the required format`,
        severity: "error",
      });
    }

    let data0 =
      await this.props.Add_Specialist_DoctorPractitioner_Specialist_insert_Updated_pSuDY(
        payload0
      );
    if (data0?.payload?.Code === 200) {
      window.location.href = "/specialist_doctor";
    }
  };
  async componentDidMount() {
    /// sample localstorage translation
    if (sessionStorage.defaultLng) {
      const { i18n } = this.props;
      i18n.changeLanguage(sessionStorage.defaultLng);
    }
    this.props.SpecialityName({ keyName: "Specialty_Name", valueName: "_id" });
    const data = await this.props.Specialist_DoctorPractitioner_Specialist_Fullread_Updated_wLNCN();
    if (!data.payload.result?.length > 0) { return }
    let arr = [];
    data.payload.result.filter(v => arr.push(v.Practitioner_Mail_ID))
    this.setState({ ...this.state, isEmail: arr });
  }

  shouldComponentUpdate(props, state) {
    if (
      this.props?.Practitioner_Specialist_insert_UpdatedData?.loading !==
      props?.Practitioner_Specialist_insert_UpdatedData?.loading
    ) {
      if (
        !props?.Practitioner_Specialist_insert_UpdatedData?.loading &&
        props?.Practitioner_Specialist_insert_UpdatedData.error
      ) {
      } else if (
        !props?.Practitioner_Specialist_insert_UpdatedData?.loading &&
        !props?.Practitioner_Specialist_insert_UpdatedData.error
      ) {
      }
    }

    return true;
  }

  render() {
    const {
      SpecialtyData,
      Practitioner_Specialist_insert_UpdatedData,
      specialityNameOptions,
      data,
    } = this.props;
    const { isError } = this.state;
    return (
      <NamespacesConsumer>
        {(t, { i18n }) => (
          <React.Fragment>
            <div key={"0"}>
              <input
                key={"0"}
                type={"hidden"}
                id={"anPageName"}
                value={"add-specialist-doctor"}
              ></input>
              <div key={"1"} class={"add-specialist-doctor screen"}>
                <div key={"0"} class={"group-93704-B47n0V"}>
                  <div key={"0"} class={"rectangle-47165-xPtKvX"}></div>
                  <div key={"1"} class={"add-specialist-doctor-xPtKvX"}>
                    Add Specialist Doctor
                  </div>
                  <img
                    key={"2"}
                    class={"line-3-xPtKvX"}
                    src={
                      "https://fileupload.dev.ainqaplatform.in/ATP_Platform_DEV/183770463"
                    }
                    alt={"line-3@1x.png"}
                  ></img>
                  <div key={"3"} class={"qdm-textinput-xPtKvX"}>
                    <TextInput
                      key={"0"}
                      onChange={(e) => this.onchange_obmtw(e)}
                      type={"text"}
                      name={t("text")}
                      variant={"outlined"}
                      helperTextType={"error"}
                      label={t("Doctor Name")}
                      error={isError?.includes("DoctorName")}
                      labelStyle={{
                        fontSize: "12px",
                        marginBottom: "5px",
                        color: "gray",
                      }}
                      autoFocus={false}
                      autoComplete={"off"}
                      search={false}
                      borderColor={"#9b9b9b"}
                      elevation={"0"}
                      placeholder={""}
                      size={"small"}
                      isRequired={true}
                      hoverColor={"#000"}
                      dateIcon={""}
                      maxLength={"100"}
                      iconText={""}
                      minLength={"0"}
                    ></TextInput>
                  </div>
                  <div key={"4"} class={"qdm-textinput-rC6gw6"}>
                    <TextInput
                      key={"0"}
                      onChange={(e) => this.onchange_shksf(e)}
                      type={"text"}
                      name={t("text")}
                      variant={"outlined"}
                      helperTextType={"error"}
                      label={t("Email Id")}
                      error={isError?.includes("EmailId")}
                      labelStyle={{
                        fontSize: "12px",
                        marginBottom: "5px",
                        color: "gray",
                      }}
                      autoFocus={false}
                      autoComplete={"off"}
                      search={false}
                      borderColor={"#9b9b9b"}
                      elevation={"0"}
                      placeholder={""}
                      size={"small"}
                      isRequired={true}
                      hoverColor={"#000"}
                      dateIcon={""}
                      maxLength={"100"}
                      iconText={""}
                      minLength={"100"}
                    ></TextInput>
                  </div>
                  <div key={"5"} class={"qdm-textinput-acJ7E3"}>
                    <TextInput
                      key={"0"}
                      onChange={(e) => this.onchange_gfves(e)}
                      type={"text"}
                      name={t("text")}
                      labelStyle={{
                        fontSize: "12px",
                        marginBottom: "5px",
                        color: "gray",
                      }}
                      variant={"outlined"}
                      helperTextType={"error"}
                      label={t("Address")}
                      autoFocus={false}
                      autoComplete={"off"}
                      search={false}
                      borderColor={"#9b9b9b"}
                      elevation={"0"}
                      placeholder={""}
                      size={"small"}
                      hoverColor={"#000"}
                      dateIcon={""}
                      maxLength={"100"}
                      iconText={""}
                      minLength={"100"}
                    ></TextInput>
                  </div>
                  <div key={"6"} class={"qdm-dropdown-xPtKvX"}>
                    <Dropdown
                      key={"0"}
                      onChange={(e) => this.onchange_9h6ec(e)}
                      elevation={"1"}
                      fullWidth={true}
                      labelStyle={{
                        fontSize: "12px",
                        marginBottom: "5px",
                        color: "gray",
                        marginTop: "0px",
                      }}
                      dropDownTextSize={"14"}
                      dropDownTextColor={"#000"}
                      activeTextColor={"#000"}
                      dropdownListMargin={"0"}
                      dropdownListPadding={"8"}
                      options={[
                        { value: "Pulau Pinang", label: "Pulau Pinang" },
                        { value: "Perak", label: "Perak" },
                        { value: "Perlis", label: "Perlis" },
                        { value: "Selangor", label: "Selangor" },
                      ]}
                      label={t("Location")}
                      error={isError?.includes("Location")}
                      isRequired={true}
                      Url={""}
                      keyName={""}
                      valueName={""}
                      style={qdmstyles.HEC}
                      inLineStyles={{ border: isError?.includes("Location") && "1px solid red", "padding": "4px 3px", "fontSize": "14px" }}
                    ></Dropdown>
                  </div>
                  <div key={"7"} class={"qdm-dropdown-rC6gw6"}>
                    <Dropdown
                      key={"0"}
                      onChange={(e) => this.onchange_yhvxc(e)}
                      elevation={"1"}
                      fullWidth={true}
                      labelStyle={{
                        fontSize: "12px",
                        marginBottom: "5px",
                        color: "gray",
                        marginTop: "0px",
                      }}
                      dropDownTextSize={"14"}
                      dropDownTextColor={"#000"}
                      activeTextColor={"#000"}
                      dropdownListMargin={"0"}
                      dropdownListPadding={"8"}
                      error={isError?.includes("Speciality")}
                      options={specialityNameOptions || []}
                      label={t("Speciality")}
                      isRequired={true}
                      Url={""}
                      keyName={""}
                      valueName={""}
                      inLineStyles={{ border: isError?.includes("Speciality") && "1px solid red", "padding": "4px 3px", "fontSize": "14px" }}
                    ></Dropdown>
                  </div>
                  <div key={"8"} class={"qdm-textinput-4sjKsh"}>
                    <TextInput
                      key={"0"}
                      onChange={(e) => this.onchange_naiin(e)}
                      type={"text"}
                      name={t("text")}
                      onKeyDown={(e) => {
                        const charCode = e.which ? e.which : e.keyCode;
                        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                          e.preventDefault()
                          return
                        }
                      }}
                      variant={"outlined"}
                      labelStyle={{
                        fontSize: "12px",
                        marginBottom: "5px",
                        color: "gray",
                      }}
                      error={isError?.includes("MobileNumber")}
                      helperTextType={"error"}
                      label={t("Mobile Number")}
                      autoFocus={false}
                      autoComplete={"off"}
                      search={false}
                      borderColor={"#9b9b9b"}
                      elevation={"0"}
                      placeholder={""}
                      size={"small"}
                      isRequired={true}
                      hoverColor={"#000"}
                      dateIcon={""}
                      maxLength={"10"}
                      iconText={""}
                      minLength={"10"}
                    // readOnly={true}
                    ></TextInput>
                  </div>
                  <div key={"9"} class={"group-93708-xPtKvX"}>
                    <div
                      key={"0"}
                      onClick={() => {
                        this.props.history.push("/specialist_doctor");
                      }}
                      class={"back-da45DN"}
                      style={{ cursor: "pointer" }}
                    >
                      Back
                    </div>
                    <img
                      key={"1"}
                      class={"path-734-da45DN"}
                      src={
                        "https://fileupload.dev.ainqaplatform.in/ATP_Platform_DEV/183772612"
                      }
                      alt={"path-734@1x.png"}
                    ></img>
                  </div>
                  <div key={"10"} class={"qdm-button-xPtKvX"}>
                    <div
                      key={"0"}
                      onClick={(e) => this.onclick_psudy(e)}
                      class={"submit-UYmVae"}
                      style={{ cursor: "pointer" }}
                    >
                      Submit
                    </div>
                  </div>
                </div>
                <div key={"1"} class={"group-93711-B47n0V"}>
                  <div key={"0"} class={"rectangle-47173-Eqnjc7"}></div>
                  <div key={"1"} class={"group-93715-Eqnjc7"}>
                    <div key={"0"} class={"logo-f4xRiC"}>
                      <img
                        key={"0"}
                        class={"x51-client_profile_subscription-10-75rJ9e"}
                        src={
                          "https://fileupload.dev.ainqaplatform.in/ATP_Platform_DEV/183739820"
                        }
                        alt={"5-1-client-profile-subscription---10@1x.png"}
                      ></img>
                      <div key={"1"} class={"global-doctors-75rJ9e"}>
                        <span key={"0"} class={"span0-YH2Lpv"}>
                          Global
                        </span>
                        <span key={"1"} class={"span1-YH2Lpv"}>
                          Doctors
                        </span>
                      </div>
                    </div>
                    <div key={"1"} class={"login-details-f4xRiC"}>
                      <div key={"0"} class={"hello-MpNhwp"}>
                        Hello{" "}
                      </div>
                      <div key={"1"} class={"mr-rakin-MpNhwp"}>
                        {sessionStorage.getItem("name")}
                      </div>
                      <div key={"2"} class={"sathishrakinainqacom-MpNhwp"}>
                        {sessionStorage.getItem("username")}
                      </div>
                      <img
                        key={"3"}
                        class={"line-9-MpNhwp"}
                        src={
                          "https://fileupload.dev.ainqaplatform.in/ATP_Platform_DEV/183744502"
                        }
                        alt={"line-9@1x.png"}
                      ></img>
                    </div>
                    <div key={"2"} class={"reports-f4xRiC"}>
                      <div
                        key={"0"}
                        onClick={() => {
                          this.props.history.push("/reports");
                        }}
                        class={"reports-PRhm9N roboto-medium-dove-gray-14px"}
                        style={{ cursor: "pointer" }}
                      >
                        Reports
                      </div>
                      <img
                        key={"1"}
                        class={"download-7-PRhm9N"}
                        src={
                          "https://fileupload.dev.ainqaplatform.in/ATP_Platform_DEV/183744506"
                        }
                        alt={"download--7-@1x.png"}
                      ></img>
                    </div>
                    <div key={"4"} class={"rectangle-47179-f4xRiC"}></div>
                    <div key={"5"} class={"master-f4xRiC"}>
                      <div
                        key={"0"}
                        class={"master-l5DuEx"}
                        style={{ cursor: "pointer" }}
                      >
                        Master
                      </div>
                      <img
                        key={"1"}
                        class={"material-master-data-l5DuEx"}
                        src={
                          "https://fileupload.dev.ainqaplatform.in/ATP_Platform_DEV/183744545"
                        }
                        alt={
                          "material-master-data-master-people-icon-with-png-and-vector-6909@1x.png"
                        }
                      ></img>
                    </div>
                    <div key={"6"} class={"group-93714-f4xRiC"}>
                      <div
                        key={"0"}
                        onClick={() => {
                          this.props.history.push("/visit_registration");
                        }}
                        class={
                          "visit-registration-MjGdxM roboto-medium-dove-gray-14px"
                        }
                        style={{ cursor: "pointer" }}
                      >
                        Visit Registration
                      </div>
                      <img
                        key={"1"}
                        class={"download-6-MjGdxM"}
                        src={
                          "https://fileupload.dev.ainqaplatform.in/ATP_Platform_DEV/183744562"
                        }
                        alt={"download--6-@1x.png"}
                      ></img>
                    </div>
                  </div>
                </div>
                <div key={"2"} class={"version-B47n0V"}>
                  <div key={"0"} class={"v1001-uvQXEm"}>
                    {"v" + localStorage?.version ?? ""}
                  </div>
                </div>
                <img
                  key={"3"}
                  class={"line-8-B47n0V"}
                  src={
                    "https://fileupload.dev.ainqaplatform.in/ATP_Platform_DEV/183770470"
                  }
                  alt={"line-8@1x.png"}
                ></img>
                <div key={"4"} class={"onsite-doctor-medical-assistant-B47n0V"}>
                  Onsite Doctor/Medical Assistant
                </div>
                <div key={"5"} class={"specialist-doctors-B47n0V"}>
                  <div key={"0"} class={"specialist-doctor-r7B79V"}>
                    Specialist Doctor
                  </div>
                  <img
                    key={"1"}
                    class={"rectangle-43868-r7B79V"}
                    src={
                      "https://fileupload.dev.ainqaplatform.in/ATP_Platform_DEV/183770484"
                    }
                    alt={"rectangle-43868@1x.png"}
                  ></img>
                </div>
                <div
                  key={"6"}
                  onClick={() => {
                    this.props.history.push("/patient_facility");
                  }}
                  class={"patient-facility-B47n0V"}
                >
                  Patient Facility
                </div>
                <div key={"7"} class={"group-93712-B47n0V"}>
                  <div key={"0"} class={"rectangle-47180-iZeJ8x"}></div>
                  <div key={"1"} class={"login-avatar-iZeJ8x"}>
                    <Logout />
                  </div>
                  <div key={"2"} class={"master-iZeJ8x"}>
                    Master
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </NamespacesConsumer>
    );
  }
}

const mapStateToProps = (state) => ({
  Practitioner_Specialist_insert_UpdatedData:
    state
      ?.Add_Specialist_DoctorPractitioner_Specialist_insert_Updated_pSuDYReducer
      ?.Practitioner_Specialist_insert_Updated_pSuDY?.data,
  specialityNameOptions:
    state.All_Dropdowns_Reducer?.specialityName?.data?.result,
});

export default connect(
  mapStateToProps,
  actions
)(withRouter(withAllContexts(translate()(AddSpecialistDoctor))));
